import { API_BASE_URL } from 'src/services/envVariableLoader';
import { Language } from 'src/store/language/languageStore.types';
import { ProjectDataStoreType } from 'src/store/projectData/projectDataStore.types';

export const getProjectData: (
  id: string,
  language: Language,
  isMobileView: boolean
) => Promise<ProjectDataStoreType['projectDetails']> = async (
  id,
  language,
  isMobileView
) => {
  const response = await fetch(
    `${API_BASE_URL}/projects/detail/${language}/${
      isMobileView ? 'lowRes' : 'highRes'
    }/${id}`
  );
  if (!response.ok) {
    throw new Error('Error occurred');
  }
  const data: ProjectDataStoreType['projectDetails'] = await response.json();
  return data;
};
